// extracted by mini-css-extract-plugin
export default {"panel":"SectionPanel_panel__lrFRl","bottomLine":"SectionPanel_bottomLine__PThvF","topLine":"SectionPanel_topLine__mXC3+","bothLines":"SectionPanel_bothLines__LOqlz"};